import './custom.css';
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OnboardingPage from './pages/OnboardingPage'
import UpdateInfoPage from './pages/UpdateInfoPage';
import HomePage from './pages/HomePage';

function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/onboarding" Component={OnboardingPage} />
        <Route path="/update_info" Component={UpdateInfoPage} />
      </Routes>
    </Router>
  );
}

export default App;